import React from 'react';
import ChartBox from '../../Custom/ChartBox';
import ChartPowerFlowForecast from './ChartPowerFlowForecast';

const PowerFlowForecast = ({ data }) => (
  <div>
    <ChartBox title={'Power Flow Forecast'}>
      <ChartPowerFlowForecast data={data} />
    </ChartBox>
  </div>
);

export default PowerFlowForecast;
